export default __webpack_public_path__ + "static/media/excel_icon.20a9ca26.png";